module.exports = __webpack_public_path__ + "img/3847ff3.png";